module.exports = __webpack_public_path__ + "img/silhouette-moon.367594e3.png";